export default __webpack_public_path__ + "img/ic_check_circle_black_24px.svg";